import PropTypes from 'prop-types'
import React  from 'react'
import { Table } from 'reactstrap'
import NotificationTemplateTableRow from './notification-template-table-row'
import { CardLoader } from 'components/organisms'
import PaginationBar from 'components/organisms/pagination-bar/pagination-bar'
import withLoader from 'hocs/with-loader'

const propTypes = {
  templates             : PropTypes.array,
  pagination            : PropTypes.object,
  onClickCancelScehdule : PropTypes.func,
  // onClickReschedule : PropTypes.func, //  TODO: waiting for api reschedule template
  onPageChange          : PropTypes.func,
  isLoading             : PropTypes.bool
}

const defaultProps = {
  templates             : [],
  pagination            : {},
  onClickCancelScehdule : () => {},
  // onClickReschedule     : () => {}, TODO: waiting for api reschedule template
  onPageChange          : () => { },
  isLoading             : false
}

const NotificationTemplateTable = ({
  templates,
  onClickCancelScehdule,
  // onClickReschedule, //TODO: waiting for api reschedule template
  onPageChange,
  pagination,
  isLoading
}) => {
  const totalColumns = 11
  const TableContent = () => (
    <Table sm responsive>
      <thead>
        <tr>
          <th colSpan={ 6 } className='text-center'>
            { 'Scheduled Blast Template' }
          </th>
        </tr>
        <tr>
          <th scope="col">{ 'id' }</th>
          <th scope="col">{ 'name' }</th>
          <th scope="col">{ 'channels' }</th>
          <th scope="col">{ 'scheduled date' }</th>
          <th scope="col">{ 'receiver target size' }</th>
          <th scope="col">{ 'actions' }</th>
        </tr>
      </thead>
      <tbody>
        {
          templates.map((template) => (
            <NotificationTemplateTableRow
              key={ `template-${template.id}` }
              scheduledTemplate={ template }
              onClickCancelScehdule={ onClickCancelScehdule }
              // onClickReschedule={ onClickReschedule } // TODO: waiting for api reschedule template
            />
          ))
        }
        {
          templates.length === 0 &&
          <tr>
            <td
              colSpan={ totalColumns }
              className='bg-warning text-white'
            >
              <i className='fas fa-info-circle mr-3' />
              { 'No Scheduled Template found based on your filters.' }
            </td>
          </tr>
        }
      </tbody>
    </Table>
  )

  const TableContentWithLoader = withLoader(TableContent, CardLoader)

  return (
    <>
      <TableContentWithLoader isLoading= { isLoading } />

      <PaginationBar
        onClickPage={ onPageChange }
        pagination={ pagination }
      />
    </>
  )
}

NotificationTemplateTable.propTypes    = propTypes
NotificationTemplateTable.defaultProps = defaultProps

export default NotificationTemplateTable
